var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 14.1004V16.6004C18.3343 16.8325 18.2867 17.0622 18.1937 17.2749C18.1008 17.4875 17.9644 17.6784 17.7934 17.8353C17.6224 17.9922 17.4205 18.1116 17.2006 18.186C16.9808 18.2603 16.7478 18.288 16.5167 18.2671C13.9523 17.9884 11.4892 17.1122 9.32498 15.7087C7.31151 14.4293 5.60443 12.7222 4.32499 10.7087C2.91663 8.53474 2.04019 6.05957 1.76665 3.48374C1.74583 3.2533 1.77321 3.02104 1.84707 2.80176C1.92092 2.58248 2.03963 2.38098 2.19562 2.21009C2.35162 2.0392 2.54149 1.90266 2.75314 1.80917C2.9648 1.71569 3.1936 1.66729 3.42499 1.66707H5.92499C6.32941 1.66309 6.72148 1.80631 7.02812 2.07002C7.33476 2.33373 7.53505 2.69995 7.59165 3.10041C7.69717 3.90046 7.89286 4.68601 8.17499 5.44207C8.2871 5.74034 8.31137 6.0645 8.24491 6.37614C8.17844 6.68778 8.02404 6.97383 7.79998 7.20041L6.74165 8.25874C7.92795 10.345 9.65536 12.0724 11.7417 13.2587L12.8 12.2004C13.0266 11.9764 13.3126 11.8219 13.6243 11.7555C13.9359 11.689 14.26 11.7133 14.5583 11.8254C15.3144 12.1075 16.0999 12.3032 16.9 12.4087C17.3048 12.4658 17.6745 12.6697 17.9388 12.9817C18.203 13.2936 18.3435 13.6917 18.3333 14.1004Z",
    stroke: "#171818",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.e45bd113542a9b865b82d385c790fa03.svg";
export { ForwardRef as ReactComponent };